// @ts-nocheck
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useTranslation } from "react-i18next";
import {
  Card,
  CardBody,
  CardTitle,
  UncontrolledTooltip
} from "reactstrap";
import "../OrderDetailAttachments/OrderDetailAttachments.scss";

import moment from "moment";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import Lightbox from "react-image-lightbox";

const OrderDetailAttachments = props => {
  const { t } = useTranslation(["order"]);
  let [data, setData] = useState(props.data);
  let [resourceType, setResourceType] = useState(props.resourceType);
  let [isLoadingResource] = useState(props.isLoadingResource);
  let [isDownloadResource, setIsDownloadResource] = useState(false);
  let [isDownloadingMultipleResources, setIsDownloadingMultipleResources] =
    useState(false);
  let [images, setImages] = useState([]);
  let [photoIndex, setPhotoIndex] = useState(-1);
  let [selectedIds, setSelectedIds] = useState([]);
  const [isGallery, setIsGallery] = useState(false);
  const [userType, setUserType] = useState(props.userType);

  const clickDownloadHandler = row => {
    props.getImagePreview(row.id);
    setIsDownloadResource(true);
  };
  const clickPreviewHandler = (row, rowIndex) => {
    setPhotoIndex(rowIndex);
    setIsGallery(true);
  };
  const clickDeleteHandler = row => {
    props.deleteResource(row.id);
  };

  const listRowAction = [
    {
      icon: <i className="fas fa-eye fa-lg text-primary" />,
      text: t("detail.attachments.previewFile"),
      onClick: clickPreviewHandler,
      roles: ["1", "2","3"],
    },
    {
      icon: <i className="fas fa-download fa-lg" />,
      text: t("detail.attachments.downloadFile"),
      onClick: clickDownloadHandler,
      roles: ["1", "2","3"],
    },
    {
      icon: <i className="fas fa-trash fa-lg text-danger" />,
      text: t("detail.attachments.deleteFile"),
      onClick: clickDeleteHandler,
      roles: ["1", "2"],
    },
  ];

  const [rowActions, setRowActions] = useState(listRowAction);

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ];
  const columns = [
    {
      dataField: "id",
      text: t("detail.attachments.no"),
      sort: true,
      formatter: function (cell, row, enumObject) {
        return `${enumObject + 1}`;
      },
    },
    {
      dataField: "maker_date",
      text: t("detail.attachments.date"),
      sort: true,
      formatter: function (cell, row, enumObject) {
        return `${moment
          .unix(new Date(Number(row?.maker_date)))
          .format("DD/MM/YYYY hh:mm:ss")}`;
      },
    },
    {
      dataField: "maker_name",
      text: t("detail.attachments.name"),
      sort: true,
    },
    {
      dataField: "file_name",
      text: t("detail.attachments.type"),
      sort: true,
      formatter: fileFormatter,
    },
    {
      dataField: "",
      text: "",
      sort: false,
      formatter: actionFormatter,
    },
  ];

  function onSelect(row, isSelect) {
    if (isSelect) {
      setSelectedIds([...selectedIds, row.id]);
    } else {
      setSelectedIds(selectedIds.filter(x => x !== row.id));
    }
  }

  function onSelectAll(isSelect, rows) {
    const ids = rows.map(r => r.id);
    if (isSelect) {
      setSelectedIds(ids);
    } else {
      setSelectedIds([]);
    }
  }

  const selectRow = {
    mode: "checkbox",
    selected: selectedIds,
    onSelect: onSelect,
    onSelectAll: onSelectAll,
  };

  function fileFormatter(cell, row, rowIndex) {
    return (
      <React.Fragment>
        <p>{resourceType[row.storage_type]}</p>
      </React.Fragment>
    );
  }
  const defaultEmptyDataMessage = () => {
    return (
      <div className="text-center">{t("detail.attachments.table_empty")}</div>
    );
  };
  function actionFormatter(cell, row, rowIndex) {
    return (
      <div
        className="d-flex gap-2 align-items-center justify-content-center"
        style={{ lineHeight: "14px" }}
      >
        {rowActions.map((action, index) => {
          return (
            <React.Fragment key={"" + index + row?.id}>
              <div
                id={"action" + index + row?.id}
                style={{
                  cursor: isLoadingResource ? "not-allowed" : "pointer",
                }}
                onClick={event => {
                  event.stopPropagation();
                  if (isLoadingResource) return;
                  action.onClick && action.onClick(row, rowIndex);
                }}
              >
                {action.icon}
                <UncontrolledTooltip
                  placement="top"
                  target={"action" + index + row?.id}
                >
                  {action.text}
                </UncontrolledTooltip>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    );
  }
  useEffect(() => {
    setData(props.data);
    setImages(
      props.data.map(x => {
        return { id: x.id, url: x.file_path };
      })
    );
  }, [props.data]);

  useEffect(() => {
    setResourceType(props.resourceType);
  }, [props.resourceType]);

  useEffect(() => {
    setUserType(props.userType);
    if (Boolean(props.userType) === true) {
      setRowActions(
        listRowAction.filter(x => x.roles.some(role => role === props.userType))
      );
    }
  }, [props.userType]);

  useEffect(() => {
    let resource = images.map((x, index) => {
      if (index === photoIndex) {
        x.url = props.resourceData;
      }
      return x;
    });

    setImages([...resource]);
  }, [props.resourceData]);

  useEffect(() => {
    if (isDownloadResource) {
      const link = document.createElement("a");
      link.target = "_blank";
      link.href = props.resourceData;
      link.download = "attachment.png";
      link.click();
      setIsDownloadResource(false);
    }
  }, [props.resourceData, isDownloadResource]);

  useEffect(() => {
    props.getImagePreview(data[photoIndex]?.id);
  }, [photoIndex]);

  useEffect(() => {
    setIsDownloadingMultipleResources(props.isDownloadingMultipleResources);
  }, [props.isDownloadingMultipleResources]);

  return (
    <Card>
      <CardBody>
        <CardTitle>
          {t("detail.attachments.title")}
          {/* <Button
            color="primary"
            className="float-end"
            style={{ backgroundColor: "#3C64B1" }}
            disabled={isDownloadingMultipleResources}
            onClick={() => {
              props.dowloadMultipleResources(selectedIds);
            }}
          >
            {t("detail.attachments.downloadFile")}
            {isDownloadingMultipleResources && (
              <Spinner style={{ marginLeft: "5px" }} color="white" size="sm" />
            )}
          </Button> */}
        </CardTitle>
        <ToolkitProvider columns={columns} keyField="id" data={data}>
          {toolkitProps => (
            <div className="table-responsive">
              <BootstrapTable
                keyField={"id"}
                responsive
                bordered={false}
                striped={false}
                defaultSorted={defaultSorted}
                selectRow={selectRow}
                classes={"table align-middle table-nowrap"}
                headerWrapperClasses={"thead-light"}
                loading={true}
                noDataIndication={defaultEmptyDataMessage}
                {...toolkitProps.baseProps}
              />
              {isGallery && !isLoadingResource && (
                <Lightbox
                  mainSrc={images[photoIndex]?.url}
                  nextSrc={images[(photoIndex + 1) % images.length]?.url}
                  prevSrc={
                    images[(photoIndex + images.length - 1) % images.length]
                      ?.url
                  }
                  enableZoom={true}
                  onCloseRequest={() => {
                    setIsGallery(false);
                  }}
                  onMovePrevRequest={() => {
                    setPhotoIndex(
                      (photoIndex + images.length - 1) % images.length
                    );
                  }}
                  onMoveNextRequest={() => {
                    setPhotoIndex((photoIndex + 1) % images.length);
                  }}
                  imageCaption={data[photoIndex]?.file_name}
                />
              )}
            </div>
          )}
        </ToolkitProvider>
      </CardBody>
    </Card>
  );
};

OrderDetailAttachments.propTypes = {
  data: PropTypes.array,
  resourceData: PropTypes.string,
  getImagePreview: PropTypes.func,
  downloadResource: PropTypes.func,
  dowloadMultipleResources: PropTypes.func,
  deleteResource: PropTypes.func,
  isLoadingResource: PropTypes.bool,
  isDownloadingMultipleResources: PropTypes.bool,
  isDeletingResource: PropTypes.bool,
  resourceType: PropTypes.object,
  userType: PropTypes.string,
};
export default OrderDetailAttachments;
